import { render } from "./HighlightCardView.vue?vue&type=template&id=4e878be6&scoped=true"
import script from "./HighlightCardView.vue?vue&type=script&lang=js"
export * from "./HighlightCardView.vue?vue&type=script&lang=js"

import "./HighlightCardView.vue?vue&type=style&index=0&id=4e878be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e878be6"]])

export default __exports__